const FacebookRoundIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8713 10.0526C18.8713 5.12256 14.899 1.12598 9.99886 1.12598C5.09877 1.12598 1.12646 5.12256 1.12646 10.0526C1.12646 14.5081 4.37095 18.2011 8.61255 18.8708V12.6329H6.35979V10.0526H8.61255V8.08595C8.61255 5.84871 9.93717 4.61294 11.9638 4.61294C12.9342 4.61294 13.9498 4.78728 13.9498 4.78728V6.98407H12.8311C11.729 6.98407 11.3852 7.67222 11.3852 8.37885V10.0526H13.8459L13.4525 12.6329H11.3852V18.8708C15.6268 18.2011 18.8713 14.5081 18.8713 10.0526Z"
      fill="currentColor"
    />
  </svg>
);

export default FacebookRoundIcon;
